export async function sendResults(apiInstance, data) {
  try {
    const response = await apiInstance.post(`/combine/results`, data);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function getResults(apiInstance, eventId, userId) {
  try {
    const response = await apiInstance.get(
      `/combine/results/${eventId}/${userId}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function sendMeasurements(apiInstance, data) {
  try {
    const response = await apiInstance.post(`/combine/measurements`, data);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function getMeasurements(apiInstance, eventId, userId) {
  try {
    const response = await apiInstance.get(
      `/combine/measurements/${eventId}/${userId}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export const getAllTimeBestResultsByEvent = async (
  apiInstance,
  UserId,
  eventId,
) => {
  try {
    const response = await apiInstance.get(
      `combine/best-results/${eventId}/${UserId}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getMeasurementsResultsByEvent = async (
  apiInstance,
  UserId,
  eventId,
) => {
  try {
    const response = await apiInstance.get(
      `combine/measurements/${UserId}/${eventId}`,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const createPositionDrillsResults = async (
  apiInstance,
  eventId,
  userId,
  drillResults,
) => {
  try {
    const response = await apiInstance.post(
      `/combine/position-drills/${eventId}/${userId}`,
      drillResults,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const updatePositionDrillsVideo = async (
  apiInstance,
  formData,
  setUploadProgress,
) => {
  try {
    const response = await apiInstance.post(
      "/combine/position-drills",
      formData,
      {
        timeout: 10 * 60 * 1000,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadProgress(percentCompleted);
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error updating position drills results:", error);
    throw error;
  }
};

export const getPositionDrillsByUserEvent = async (
  apiInstance,
  userId,
  eventId,
) => {
  try {
    const response = await apiInstance.get(
      `/combine/position-drills/${eventId}/${userId}`,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const deletePositionDrill = async (apiInstance, positionDrillId) => {
  try {
    const response = await apiInstance.delete(
      `/combine/${positionDrillId}/position-drills`,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const updatePositionDrillCoachingTip = async (
  apiInstance,
  positionDrillId,
  coachingTip,
) => {
  try {
    const response = await apiInstance.post(
      `/combine/position-drill-tip/${positionDrillId}`,
      { coachingTip },
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};
